import { render, staticRenderFns } from "./NewCurrency.vue?vue&type=template&id=38521d8c&scoped=true&"
import script from "./NewCurrency.vue?vue&type=script&lang=js&"
export * from "./NewCurrency.vue?vue&type=script&lang=js&"
import style0 from "./NewCurrency.vue?vue&type=style&index=0&id=38521d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38521d8c",
  null
  
)

export default component.exports